import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Node } from '@atlaskit/editor-prosemirror/model';
export var ProseMirrorContentStatistics = /*#__PURE__*/function () {
  function ProseMirrorContentStatistics(content) {
    _classCallCheck(this, ProseMirrorContentStatistics);
    this.content = content;
  }

  /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */
  return _createClass(ProseMirrorContentStatistics, [{
    key: "collectStatistics",
    value: function collectStatistics() {
      var _this$countNodesAndMa = this.countNodesAndMarks(),
        nodeCounts = _this$countNodesAndMa.nodeCounts,
        markCounts = _this$countNodesAndMa.markCounts,
        linksCount = _this$countNodesAndMa.linksCount,
        mentionsCount = _this$countNodesAndMa.mentionsCount;
      var _this$calculateCharac = this.calculateCharacterCounts(),
        totalCharacterCount = _this$calculateCharac.totalCharacterCount;
      return {
        nodeCounts: nodeCounts,
        markCounts: markCounts,
        linksCount: linksCount,
        mentionsCount: mentionsCount,
        totalCharacterCount: totalCharacterCount,
        contextSelectionScope: undefined
      };
    }
  }, {
    key: "countNodesAndMarks",
    value: function countNodesAndMarks() {
      var nodeCounts = new Map();
      var markCounts = new Map();
      var linksCount = 0;
      var mentionsCount = 0;
      this.content.descendants(function (node) {
        nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
        var marks = node.marks;
        marks.forEach(function (mark) {
          markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
        });
        var _node$type$schema = node.type.schema,
          _node$type$schema$nod = _node$type$schema.nodes,
          inlineCard = _node$type$schema$nod.inlineCard,
          mention = _node$type$schema$nod.mention,
          link = _node$type$schema.marks.link;
        if (node.type === mention) {
          mentionsCount++;
        }
        if (node.type === inlineCard && node.attrs.url) {
          linksCount++;
        }
        if (marks.find(function (mark) {
          return mark.type === link;
        })) {
          linksCount++;
        }
      });
      return {
        nodeCounts: Object.fromEntries(nodeCounts),
        markCounts: Object.fromEntries(markCounts),
        linksCount: linksCount,
        mentionsCount: mentionsCount
      };
    }
  }, {
    key: "calculateCharacterCounts",
    value: function calculateCharacterCounts() {
      var allTextContent = '';
      if (this.content instanceof Node) {
        allTextContent = this.content.textContent;
      } else {
        this.content.forEach(function (child) {
          allTextContent += child.textContent;
        });
      }
      return {
        totalCharacterCount: allTextContent.length
      };
    }
  }]);
}();